import axios from 'axios';
import { API_ROOT } from '../config/appConfig';

// Accepts an organization invitation. Public: the visitor follows the link from
// their email and is not signed in yet, so no bearer token is sent.
// Throws on a rejected/expired token so the caller can surface the reason.
export const acceptInvitationApi = async (token) => {
  const res = await axios.post(
    `${API_ROOT}/user-management/invitations/accept/${token}`,
    {},
    {
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  return res.data;
};

export default acceptInvitationApi;
